import React, { Component } from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import scrollToComponent from 'react-scroll-to-component';
import ReactDOM from 'react-dom';
import Login from '../View/Login';
import BG from '../images/table6IconBg.svg';
import '../css/table.css';
import {
  ShareButtons,
  generateShareIcon
} from 'react-share'
const {
  FacebookShareButton,
  GooglePlusShareButton
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const GooglePlusIcon = generateShareIcon('google');

class Table6 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      send: false,
      loading: false,
      ans1: false,
      ans2: false,
      ans3: false,
      ans4: false,
      ans5: false,
      ans6: false,
      ans7: false,
      ans8: false,
      ans9: false,
      ans10: false,
      ans11: false,
      ans12: false,
      ans13: false,
      ans14: false,
      ans15: false,
      ans16: false,
      ans17: false,
      ans18: false,
      name: '憂鬱自我診斷',
      totalTest:'',
      url: 'herbalcure.com.tw/Table6',
      thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable6.jpg?alt=media&token=94a8b6c6-e786-4c4c-b1c4-29c5a2cd6024',
      fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable6.jpg?alt=media&token=94a8b6c6-e786-4c4c-b1c4-29c5a2cd6024'
    }
    this.tableBox = this.tableBox.bind(this)
    this.handleChangeAns1 = this.handleChangeAns1.bind(this)
    this.handleChangeAns2 = this.handleChangeAns2.bind(this)
    this.handleChangeAns3 = this.handleChangeAns3.bind(this)
    this.handleChangeAns4 = this.handleChangeAns4.bind(this)
    this.handleChangeAns5 = this.handleChangeAns5.bind(this)
    this.handleChangeAns6 = this.handleChangeAns6.bind(this)
    this.handleChangeAns7 = this.handleChangeAns7.bind(this)
    this.handleChangeAns8 = this.handleChangeAns8.bind(this)
    this.handleChangeAns9 = this.handleChangeAns9.bind(this)
    this.handleChangeAns10 = this.handleChangeAns10.bind(this)
    this.handleChangeAns11 = this.handleChangeAns11.bind(this)
    this.handleChangeAns12 = this.handleChangeAns12.bind(this)
    this.handleChangeAns13 = this.handleChangeAns13.bind(this)
    this.handleChangeAns14 = this.handleChangeAns14.bind(this)
    this.handleChangeAns15 = this.handleChangeAns15.bind(this)
    this.handleChangeAns16 = this.handleChangeAns16.bind(this)
    this.handleChangeAns17 = this.handleChangeAns17.bind(this)
    this.handleChangeAns18 = this.handleChangeAns18.bind(this)
    this.goToTable2 = this.goToTable2.bind(this)
    this.goToTable3 = this.goToTable3.bind(this)
    this.goToTable4 = this.goToTable4.bind(this)
    this.goToTable5 = this.goToTable5.bind(this)
    this.goToTable6 = this.goToTable6.bind(this)
    this.tableSave = this.tableSave.bind(this)
  }
  componentDidMount() {
    window.scrollTo(0,0)
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        const totalTestTableRef = firebase.database().ref().child('total')
        totalTestTableRef.on('value', snap => {
          this.setState({
            totalTest: snap.val().totalTest
          })
        })
       console.log(this.state.totalTest)
      } else {
        tableBox.classList.remove('isShow')
      }
    })
  }
  tableBox() {
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        scrollToComponent(tableBox, {
        	offset: -50,
        	align: 'top',
        	duration: 700
        })
      } else {
        tableBox.classList.remove('isShow')
        this.setState({ send: true})
        setTimeout(() => this.setState({ loading: true }), 400);
      }
    })
  }
  goToTable2() {
    const table1 = ReactDOM.findDOMNode(this.refs.table1)
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    table1.classList.remove('isShow')
    table2.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is17')
  }
  goToTable3() {
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    table2.classList.remove('isShow')
    table3.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is34')
  }
  goToTable4() {
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    table3.classList.remove('isShow')
    table4.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is51')
  }
  goToTable5() {
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    table4.classList.remove('isShow')
    table5.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is68')
  }
  goToTable6() {
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    const table6 = ReactDOM.findDOMNode(this.refs.table6)
    table5.classList.remove('isShow')
    table6.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is85')
  }
  tableSave(event) {
    event.preventDefault()
    const totalTestTableRef = firebase.database().ref().child('total')
    totalTestTableRef.update({
      totalTest: (this.state.totalTest * 1) + 1
    })
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.add('is100')
    const userId = firebase.auth().currentUser.uid
    const rootRef = firebase.database().ref('users/').child(userId).child('Answers').push()
    const postId = rootRef.key
    const total = ( (this.state.ans1 * 1) + (this.state.ans2 * 1) + (this.state.ans3 * 1) + (this.state.ans4 * 1) + (this.state.ans5 * 1) + (this.state.ans6 * 1) + (this.state.ans7 * 1) + (this.state.ans8 * 1) + (this.state.ans9 * 1) + (this.state.ans10 * 1) + (this.state.ans11 * 1) + (this.state.ans12 * 1) + (this.state.ans13 * 1) + (this.state.ans14 * 1) + (this.state.ans15 * 1) + (this.state.ans16 * 1) + (this.state.ans17 * 1) + (this.state.ans18 * 1) )
    if (total < 10) {
      rootRef.update({
        Reviews: '真令人羨慕/你目前的情緒狀態很穩定，是個懂得適時調整情緒及紓解壓力的人，繼續保持下去。',
        ans: total,
        name: '憂鬱自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table6',
        localUrl: '/Table6',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable6.jpg?alt=media&token=94a8b6c6-e786-4c4c-b1c4-29c5a2cd6024',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable6.jpg?alt=media&token=94a8b6c6-e786-4c4c-b1c4-29c5a2cd6024'
      })
    } else if (total < 25) {
      rootRef.update({
        Reviews: '最近的情緒是否起伏不定?給自已多點關心，多注意情緒的變化，做適時的處理，比較不會陷入憂鬱情緒。',
        ans: total,
        name: '憂鬱自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table6',
        localUrl: '/Table6',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable6.jpg?alt=media&token=94a8b6c6-e786-4c4c-b1c4-29c5a2cd6024',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable6.jpg?alt=media&token=94a8b6c6-e786-4c4c-b1c4-29c5a2cd6024'
      })
    } else if(total < 30) {
      rootRef.update({
        Reviews: '你是不是有許多事壓在心上，肩上總覺得很沉重?千萬別再「撐」了!趕快找個有相同經驗的朋友聊聊，給心找個出口。',
        ans: total,
        name: '憂鬱自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table6',
        localUrl: '/Table6',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable6.jpg?alt=media&token=94a8b6c6-e786-4c4c-b1c4-29c5a2cd6024',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable6.jpg?alt=media&token=94a8b6c6-e786-4c4c-b1c4-29c5a2cd6024'
      })
    } else if(total < 45) {
      rootRef.update({
        Reviews: '現在的你必定無法展露笑容，一肚子苦惱及煩悶，趕緊找專業機構或醫療單位協助。',
        ans: total,
        name: '憂鬱自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table6',
        localUrl: '/Table6',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable6.jpg?alt=media&token=94a8b6c6-e786-4c4c-b1c4-29c5a2cd6024',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable6.jpg?alt=media&token=94a8b6c6-e786-4c4c-b1c4-29c5a2cd6024'
      })
    } else {
      rootRef.update({
        Reviews: '你的身心已經嚴重「感冒」，你是不是會不由自主的感到情緒低落、想哭、無可自拔? 生活上和人際關係上也開始出現各種障礙!憂鬱症臨床上的症狀為: \n (1)情緒低落、(2)明顯對事物失去興趣、(3)體重下降或上升、(4)嗜睡或失眠、(5)精神運動遲滯、(6)容易疲倦或失去活力、(7)無價值感或強烈罪惡感、(8)注意力不集中或猶豫不決、(9)經常想到死亡若你有以上症狀，最好儘早找專業的醫師診斷，並接受精神科的專業治療，透過藥物、心理治療，排除外在壓力事件，將可讓病情好轉。我們也幫你整理了憂鬱症的資訊給你，希望能為你帶來更多幫助。',
        ans: total,
        name: '憂鬱自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table6',
        localUrl: '/Table6',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable6.jpg?alt=media&token=94a8b6c6-e786-4c4c-b1c4-29c5a2cd6024',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable6.jpg?alt=media&token=94a8b6c6-e786-4c4c-b1c4-29c5a2cd6024'
      })
    }
    window.location = ('/Answer/' + postId);
  }
  handleChangeAns1(event) {
    this.setState({ans1: event.target.value});
    const toQ2 = ReactDOM.findDOMNode(this.refs.toQ2)
    scrollToComponent(toQ2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns2(event) {
    this.setState({ans2: event.target.value});
    const toQ3 = ReactDOM.findDOMNode(this.refs.toQ3)
    scrollToComponent(toQ3, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns3(event) {
    this.setState({ans3: event.target.value});
    const toNext1 = ReactDOM.findDOMNode(this.refs.toNext1)
    scrollToComponent(toNext1, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns4(event) {
    this.setState({ans4: event.target.value});
    const toQ5 = ReactDOM.findDOMNode(this.refs.toQ5)
    scrollToComponent(toQ5, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns5(event) {
    this.setState({ans5: event.target.value});
    const toQ6 = ReactDOM.findDOMNode(this.refs.toQ6)
    scrollToComponent(toQ6, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns6(event) {
    this.setState({ans6: event.target.value});
    const toNext2 = ReactDOM.findDOMNode(this.refs.toNext2)
    scrollToComponent(toNext2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns7(event) {
    this.setState({ans7: event.target.value});
    const toQ8 = ReactDOM.findDOMNode(this.refs.toQ8)
    scrollToComponent(toQ8, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns8(event) {
    this.setState({ans8: event.target.value});
    const toQ9 = ReactDOM.findDOMNode(this.refs.toQ9)
    scrollToComponent(toQ9, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns9(event) {
    this.setState({ans9: event.target.value});
    const toNext3 = ReactDOM.findDOMNode(this.refs.toNext3)
    scrollToComponent(toNext3, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns10(event) {
    this.setState({ans10: event.target.value});
    const toQ11 = ReactDOM.findDOMNode(this.refs.toQ11)
    scrollToComponent(toQ11, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns11(event) {
    this.setState({ans11: event.target.value});
    const toQ12 = ReactDOM.findDOMNode(this.refs.toQ12)
    scrollToComponent(toQ12, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns12(event) {
    this.setState({ans12: event.target.value});
    const toNext4 = ReactDOM.findDOMNode(this.refs.toNext4)
    scrollToComponent(toNext4, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns13(event) {
    this.setState({ans13: event.target.value});
    const toQ14 = ReactDOM.findDOMNode(this.refs.toQ14)
    scrollToComponent(toQ14, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns14(event) {
    this.setState({ans14: event.target.value});
    const toQ15 = ReactDOM.findDOMNode(this.refs.toQ15)
    scrollToComponent(toQ15, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns15(event) {
    this.setState({ans15: event.target.value});
    const toNext5 = ReactDOM.findDOMNode(this.refs.toNext5)
    scrollToComponent(toNext5, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns16(event) {
    this.setState({ans16: event.target.value});
    const toQ17 = ReactDOM.findDOMNode(this.refs.toQ17)
    scrollToComponent(toQ17, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns17(event) {
    this.setState({ans17: event.target.value});
    const toQ18 = ReactDOM.findDOMNode(this.refs.toQ18)
    scrollToComponent(toQ18, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns18(event) {
    this.setState({ans18: event.target.value});
    const toNext6 = ReactDOM.findDOMNode(this.refs.toNext6)
    scrollToComponent(toNext6, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  render(postId) {
    const { loading } = this.state;
    if(loading) {
      return <div style={{display: this.state.send ? 'flex' : 'none', background: '#eeede9',justifyContent: 'center', alignItems:'center'}} >
        <Login />
      </div>
    }
    const nextBtn1 = ((this.state.ans1 + this.state.ans2 + this.state.ans3) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable2}>下一題</div>
     : null
    const nextBtn2 = ((this.state.ans4 + this.state.ans5 + this.state.ans6) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable3}>下一題</div>
     : null
    const nextBtn3 = ((this.state.ans7 + this.state.ans8 + this.state.ans9) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable4}>再接再厲</div>
     : null
    const nextBtn4 = ((this.state.ans10 + this.state.ans11 + this.state.ans12) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable5}>下一題</div>
     : null
    const nextBtn5 = ((this.state.ans13 + this.state.ans14 + this.state.ans15) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable6}>再接再厲</div>
     : null
    const nextBtn6 = ((this.state.ans16 + this.state.ans17 + this.state.ans18) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.tableSave}>完成!提交吧</div>
     : null
    return (
      <div>
        <MetaTags>
            <title>草學藥事 || {this.state.name}</title>
            <meta id="og-title" property="og:title" content={this.state.name} />
        </MetaTags>
        <div className="animationBox" style={Jeyu.Banner} ref="banner">
         <div className="container">
          <div className="row">
          <div style={Jeyu.Slogan} className="slogan table6">
           <h1>你有憂鬱症傾向嗎?</h1>
           <h2>找出原因 及早治療</h2>
           <p className="moileNone">
           總是提不起勁，人生活得好累好煩!<br />
           憂鬱本身是一種「失落」及「無望感」<br />
           及早發現並治療，不向憂鬱低頭!
           </p>
           <span className="tableBtnDefault" onClick={this.tableBox}>開始檢測</span>
           <article className="fbBox">
                  <div className="Demo__some-network">
                     <FacebookShareButton
                       url='https://herbalcure.com.tw/Table6'
                       quote={this.state.name}
                       className="Demo__some-network__share-button">
                       <FacebookIcon
                         size={26}
                         round />
                     </FacebookShareButton>
                   </div>
                   <div className="Demo__some-network">
                     <GooglePlusShareButton
                       url='https://herbalcure.com.tw/Table6'
                       className="Demo__some-network__share-button">
                       <GooglePlusIcon
                         size={26}
                         round />
                     </GooglePlusShareButton>
                   </div>
           </article>
          </div>
          </div>
         </div>
        </div>
        <div className="tableBox table2Height" ref="tableBox" style={Jeyu.tableBox}>
         <div className="container">
          <div className="row">
          <div className="tableFlexBox">
           <div className="mobilePd20">
            <h2>憂鬱自我診斷</h2>
            <sub>請依據最近兩周內身體與情緒的感覺來做選擇<br />
             <span>沒有或極少(每周一天以下)</span>
             <span>有時候(每周有1~2天)</span>
             <span>時常(每周3~4天)</span>
             <span>總是(每周5~7天)</span>
            </sub>
           </div>
            <div className="sliderBar" ref="sliderBar"></div>
            <section className="">
             <form className="tableForm">
              <div className="table1 isShow" ref="table1">
              <article ref="toQ2">
               <h1>Q1:我想哭?</h1>
               <input type="radio" value='1'
                id="ans1"
                checked={this.state.ans1 === '1'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans1">極少</label>
               <input type="radio" value='2'
                id="ans2"
                checked={this.state.ans1 === '2'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans2">有時</label>
               <input type="radio" value='3'
                id="ans3"
                checked={this.state.ans1 === '3'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans3">時常</label>
               <input type="radio" value='5'
                id="ans4"
                checked={this.state.ans1 === '5'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans4">總是</label>
              </article>
              <article ref="toQ3">
               <h1>Q2:我心情不好?</h1>
               <input type="radio" value='1'
                id="ans5"
                checked={this.state.ans2 === '1'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans5">極少</label>
               <input type="radio" value='2'
                id="ans6"
                checked={this.state.ans2 === '2'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans6">有時</label>
               <input type="radio" value='3'
                id="ans7"
                checked={this.state.ans2 === '3'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans7">時常</label>
               <input type="radio" value='5'
                id="ans8"
                checked={this.state.ans2 === '5'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans8">總是</label>
              </article>
              <article ref="toNex1">
               <h1>Q3:我覺得比以前容易發脾氣?</h1>
               <input type="radio" value='1'
                id="ans9"
                checked={this.state.ans3 === '1'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans9">極少</label>
               <input type="radio" value='2'
                id="ans10"
                checked={this.state.ans3 === '2'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans10">有時</label>
               <input type="radio" value='3'
                id="ans11"
                checked={this.state.ans3 === '3'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans11">時常</label>
               <input type="radio" value='5'
                id="ans12"
                checked={this.state.ans3 === '5'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans12">總是</label>
              </article>
               <div>{ nextBtn1 }</div>
              </div>
              <div className="table2" ref="table2">
              <article ref="toQ5">
               <h1>Q4:我常常睡不好?</h1>
               <input type="radio" value='1'
                id="ans13"
                checked={this.state.ans4 === '1'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans13">極少</label>
               <input type="radio" value='2'
                id="ans14"
                checked={this.state.ans4 === '2'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans14">有時</label>
               <input type="radio" value='3'
                id="ans15"
                checked={this.state.ans4 === '3'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans15">時常</label>
               <input type="radio" value='5'
                id="ans16"
                checked={this.state.ans4 === '5'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans16">總是</label>
              </article>
              <article ref="toQ6">
               <h1>Q5:我常常覺得不想吃東西?</h1>
               <input type="radio" value='1'
                id="ans17"
                checked={this.state.ans5 === '1'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans17">極少</label>
               <input type="radio" value='2'
                id="ans18"
                checked={this.state.ans5 === '2'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans18">有時</label>
               <input type="radio" value='3'
                id="ans19"
                checked={this.state.ans5 === '3'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans19">時常</label>
               <input type="radio" value='5'
                id="ans20"
                checked={this.state.ans5 === '5'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans20">總是</label>
              </article>
              <article ref="toNext2">
               <h1>Q6:我覺得胸口悶悶的(心肝頭或胸坎綁綁)?</h1>
               <input type="radio" value='1'
                id="ans21"
                checked={this.state.ans6 === '1'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans21">極少</label>
               <input type="radio" value='2'
                id="ans22"
                checked={this.state.ans6 === '2'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans22">有時</label>
               <input type="radio" value='3'
                id="ans23"
                checked={this.state.ans6 === '3'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans23">時常</label>
               <input type="radio" value='5'
                id="ans24"
                checked={this.state.ans6 === '5'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans24">總是</label>
              </article>
               <div>{ nextBtn2 }</div>
              </div>
              <div className="table3" ref="table3">
              <article ref="toQ8">
               <h1>Q7:我覺得不輕鬆、不舒服 ( 不爽快 )?</h1>
               <input type="radio" value='1'
                id="ans25"
                checked={this.state.ans7 === '1'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans25">極少</label>
               <input type="radio" value='2'
                id="ans26"
                checked={this.state.ans7 === '2'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans26">有時</label>
               <input type="radio" value='3'
                id="ans27"
                checked={this.state.ans7 === '3'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans27">時常</label>
               <input type="radio" value='5'
                id="ans28"
                checked={this.state.ans7 === '5'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans28">總是</label>
              </article>
              <article ref="toQ9">
               <h1>Q8:我覺得身體疲勞虛弱、無力(身體很虛、沒力氣、元氣及體力)?</h1>
               <input type="radio" value='1'
                id="ans29"
                checked={this.state.ans8 === '1'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans29">極少</label>
               <input type="radio" value='2'
                id="ans30"
                checked={this.state.ans8 === '2'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans30">有時</label>
               <input type="radio" value='3'
                id="ans31"
                checked={this.state.ans8 === '3'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans31">時常</label>
               <input type="radio" value='5'
                id="ans32"
                checked={this.state.ans8 === '5'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans32">總是</label>
              </article>
              <article ref="toNex3">
               <h1>Q9:我覺得很煩?</h1>
               <input type="radio" value='1'
                id="ans33"
                checked={this.state.ans9 === '1'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans33">極少</label>
               <input type="radio" value='2'
                id="ans34"
                checked={this.state.ans9 === '2'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans34">有時</label>
               <input type="radio" value='3'
                id="ans35"
                checked={this.state.ans9 === '3'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans35">時常</label>
               <input type="radio" value='5'
                id="ans36"
                checked={this.state.ans9 === '5'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans36">總是</label>
              </article>
               <div>{ nextBtn3 }</div>
              </div>
              <div className="table4" ref="table4">
              <article ref="toQ11">
               <h1>Q10:我覺得記憶力不好?</h1>
               <input type="radio" value='1'
                id="ans37"
                checked={this.state.ans10 === '1'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans37">極少</label>
               <input type="radio" value='2'
                id="ans38"
                checked={this.state.ans10 === '2'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans38">有時</label>
               <input type="radio" value='3'
                id="ans39"
                checked={this.state.ans10 === '3'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans39">時常</label>
               <input type="radio" value='5'
                id="ans40"
                checked={this.state.ans10 === '5'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans40">總是</label>
              </article>
              <article ref="toQ12">
               <h1>Q11:我覺得做事時無法專心?</h1>
               <input type="radio" value='1'
                id="ans41"
                checked={this.state.ans11 === '1'}
                onChange={this.handleChangeAns11} />
               <label htmlFor="ans41">極少</label>
               <input type="radio" value='2'
                id="ans42"
                checked={this.state.ans11 === '2'}
                onChange={this.handleChangeAns11} />
               <label htmlFor="ans42">有時</label>
               <input type="radio" value='3'
                id="ans43"
                checked={this.state.ans11 === '3'}
                onChange={this.handleChangeAns11} />
               <label htmlFor="ans43">時常</label>
               <input type="radio" value='5'
                id="ans44"
                checked={this.state.ans11 === '5'}
                onChange={this.handleChangeAns11} />
               <label htmlFor="ans44">總是</label>
              </article>
              <article ref="toNext4">
               <h1>Q12:我覺得想事情或做事時比平常要緩慢?</h1>
               <input type="radio" value='1'
                id="ans45"
                checked={this.state.ans12 === '1'}
                onChange={this.handleChangeAns12} />
               <label htmlFor="ans45">極少</label>
               <input type="radio" value='2'
                id="ans46"
                checked={this.state.ans12 === '2'}
                onChange={this.handleChangeAns12} />
               <label htmlFor="ans46">有時</label>
               <input type="radio" value='3'
                id="ans47"
                checked={this.state.ans12 === '3'}
                onChange={this.handleChangeAns12} />
               <label htmlFor="ans47">時常</label>
               <input type="radio" value='5'
                id="ans48"
                checked={this.state.ans12 === '5'}
                onChange={this.handleChangeAns12} />
               <label htmlFor="ans48">總是</label>
              </article>
               <div>{ nextBtn4 }</div>
              </div>
              <div className="table5" ref="table5">
              <article ref="toQ14">
               <h1>Q13:我覺得比前沒信心?</h1>
               <input type="radio" value='1'
                id="ans49"
                checked={this.state.ans13 === '1'}
                onChange={this.handleChangeAns13} />
               <label htmlFor="ans49">極少</label>
               <input type="radio" value='2'
                id="ans50"
                checked={this.state.ans13 === '2'}
                onChange={this.handleChangeAns13} />
               <label htmlFor="ans50">有時</label>
               <input type="radio" value='3'
                id="ans51"
                checked={this.state.ans13 === '3'}
                onChange={this.handleChangeAns13} />
               <label htmlFor="ans51">時常</label>
               <input type="radio" value='5'
                id="ans52"
                checked={this.state.ans13 === '5'}
                onChange={this.handleChangeAns13} />
               <label htmlFor="ans52">總是</label>
              </article>
              <article ref="toQ15">
               <h1>Q14:我覺得比較會往壞處想?</h1>
               <input type="radio" value='1'
                id="ans53"
                checked={this.state.ans14 === '1'}
                onChange={this.handleChangeAns14} />
               <label htmlFor="ans53">極少</label>
               <input type="radio" value='2'
                id="ans54"
                checked={this.state.ans14 === '2'}
                onChange={this.handleChangeAns14} />
               <label htmlFor="ans54">有時</label>
               <input type="radio" value='3'
                id="ans55"
                checked={this.state.ans14 === '3'}
                onChange={this.handleChangeAns14} />
               <label htmlFor="ans55">時常</label>
               <input type="radio" value='5'
                id="ans56"
                checked={this.state.ans14 === '5'}
                onChange={this.handleChangeAns14} />
               <label htmlFor="ans56">總是</label>
              </article>
              <article ref="toNext5">
               <h1>Q15:我覺得想不開、甚至想死?</h1>
               <input type="radio" value='1'
                id="ans57"
                checked={this.state.ans15 === '1'}
                onChange={this.handleChangeAns15} />
               <label htmlFor="ans57">極少</label>
               <input type="radio" value='2'
                id="ans58"
                checked={this.state.ans15 === '2'}
                onChange={this.handleChangeAns15} />
               <label htmlFor="ans58">有時</label>
               <input type="radio" value='3'
                id="ans59"
                checked={this.state.ans15 === '3'}
                onChange={this.handleChangeAns15} />
               <label htmlFor="ans59">時常</label>
               <input type="radio" value='5'
                id="ans60"
                checked={this.state.ans15 === '5'}
                onChange={this.handleChangeAns15} />
               <label htmlFor="ans60">總是</label>
              </article>
               <div>{ nextBtn5 }</div>
              </div>
              <div className="table6" ref="table6">
              <article ref="toQ17">
               <h1>Q16:我覺得對甚麼事都失去興趣?</h1>
               <input type="radio" value='1'
                id="ans61"
                checked={this.state.ans16 === '1'}
                onChange={this.handleChangeAns16} />
               <label htmlFor="ans61">極少</label>
               <input type="radio" value='2'
                id="ans62"
                checked={this.state.ans16 === '2'}
                onChange={this.handleChangeAns16} />
               <label htmlFor="ans62">有時</label>
               <input type="radio" value='3'
                id="ans63"
                checked={this.state.ans16 === '3'}
                onChange={this.handleChangeAns16} />
               <label htmlFor="ans63">時常</label>
               <input type="radio" value='5'
                id="ans64"
                checked={this.state.ans16 === '5'}
                onChange={this.handleChangeAns16} />
               <label htmlFor="ans64">總是</label>
              </article>
              <article ref="toQ18">
               <h1>Q17:我覺得身體不舒服(如頭痛、頭暈、心悸、肚子不舒服等)?</h1>
               <input type="radio" value='1'
                id="ans65"
                checked={this.state.ans17 === '1'}
                onChange={this.handleChangeAns17} />
               <label htmlFor="ans65">極少</label>
               <input type="radio" value='2'
                id="ans66"
                checked={this.state.ans17 === '2'}
                onChange={this.handleChangeAns17} />
               <label htmlFor="ans66">有時</label>
               <input type="radio" value='3'
                id="ans67"
                checked={this.state.ans17 === '3'}
                onChange={this.handleChangeAns17} />
               <label htmlFor="ans67">時常</label>
               <input type="radio" value='5'
                id="ans68"
                checked={this.state.ans17 === '5'}
                onChange={this.handleChangeAns17} />
               <label htmlFor="ans68">總是</label>
              </article>
              <article ref="toNext6">
               <h1>Q18:我覺得自己很沒用?</h1>
               <input type="radio" value='1'
                id="ans69"
                checked={this.state.ans18 === '1'}
                onChange={this.handleChangeAns18} />
               <label htmlFor="ans69">極少</label>
               <input type="radio" value='2'
                id="ans70"
                checked={this.state.ans18 === '2'}
                onChange={this.handleChangeAns18} />
               <label htmlFor="ans70">有時</label>
               <input type="radio" value='3'
                id="ans71"
                checked={this.state.ans18 === '3'}
                onChange={this.handleChangeAns18} />
               <label htmlFor="ans71">時常</label>
               <input type="radio" value='5'
                id="ans72"
                checked={this.state.ans18 === '5'}
                onChange={this.handleChangeAns18} />
               <label htmlFor="ans72">總是</label>
              </article>
               <div>{ nextBtn6 }</div>
              </div>
             </form>
            </section>
            </div>
          </div>
         </div>
        </div>
      </div>
    )
  }
}

export default Table6;

const Jeyu = {
  Banner: {
    background: 'url('+BG+') center center/ 120%',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  Slogan: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '5px solid #325aaa',
    textAlign: 'center',
    padding: '20px 40px',
    flexDirection: 'column'
  },
  tableBox: {
    background: '#9483de'
  }
}



// WEBPACK FOOTER //
// ./src/Tables/table6.js